import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Layout from '../components/layout'
import Seo from '../components/seo'
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'

const AvisoPrivacidad = () => (
  <Layout>
    <Seo
      title='Aviso de privacidad Amerex México'
      description='Usted tiene derecho a saber la manera en que utilizamos sus datos personales. Aquí puede ver las cláusulas y en caso de duda puede ponerse en contacto con nuestro personal en info@amerex.mx o al teléfono (81) 1534-9214.'
    />
    <div className='col-12 col-md-10 mx-auto my-5 px-4'>
      <h1>Aviso de privacidad</h1>
      <p>
        Amerex México, S.A. de C.V. es una empresa orientada a la distribución,
        venta e instalación de equipo contra incendios y estamos ubicados en
        Sonora 768 Sur Monterrey, Nuevo León. Puede contactarnos por teléfono
        al: (81) 1534-9214 o atraves del correo electrónico info@amerex.mx
        <br />
        Sus datos personales serán tratados por Amerex México. Este Aviso de
        Privacidad forma parte del sitio www.amerex.mx
      </p>
      <p className='fw-bold lead fs-4 mb-0'>Datos personales que solicitamos</p>
      <p>La información solicitada al usuario es:</p>
      <ol>
        <li>Nombre y apellidos</li>
        <li>Dirección de correo electrónico </li>
        <li>Número telefónico</li>
      </ol>
      <p>
        La información que recibimos de parte del usuario deberá ser veraz y
        completa. El usuario responderá en todo momento por la veracidad de los
        datos proporcionados y en ningún caso Amerex México será responsable a
        este respecto.
      </p>
      <p className='lead fs-4 fw-bold mb-0'>Uso de la información</p>
      <p>
        La información solicitada permite a Amerex México proporcionar la
        información solicitada por el usuario através del sitio de internet. En
        todo momento usted podrá revocar el consentimiento que nos ha otorgado
        para el tratamiento de sus datos personales. Para ello, es necesario que
        presente su petición mediante un correo electrónico a info@amerex.mx Su
        petición deberá ir acompañada de los fundamentos por los que solicita
        dicha revocación y un documento oficial de identificación personal. En
        un plazo máximo de 20 (veinte) días hábiles atenderemos su solicitud y
        le informaremos sobre la procedencia de la misma a través del correo
        electrónico del que provenga la petición.
      </p>
      <p className='lead fs-4 fw-bold mb-0'>
        Limitación de uso y divulgación de información
      </p>
      <p>
        Sólo Amerex México tiene acceso a la información recabada en nuestro
        sitio web.
      </p>
      <p className='lead fs-4 fw-bold mb-0'>
        Transferencias de información con terceros
      </p>
      <p>
        Amerex México no realiza transferencias de información con terceros.
      </p>
      <p className='lead fs-4 fw-bold mb-0'>Datos personales sensibles</p>
      <p>
        Amerex México no solicita datos personales sensibles en su sitio web.
      </p>
      <p className='lead fs-4 fw-bold mb-0 '>
        Qué son los cookies y cómo se utilizan
      </p>
      <p>
        Los cookies son pequeñas piezas de información que son enviadas por el
        sitio Web a su navegador y se almacenan en el disco duro de su equipo y
        se utilizan para determinar sus preferencias cuando se conecta a los
        servicios de nuestros sitios, así como para rastrear determinados
        comportamientos o actividades llevadas a cabo por usted dentro de
        nuestros sitios.
      </p>
      <p>
        En algunas secciones de nuestro sitio requerimos que el cliente tenga
        habilitados los cookies ya que algunas de las funcionalidades requieren
        de éstas para trabajar. La utilización de cookies no será empleada para
        identificar a los usuarios, con excepción de los casos en que se
        investiguen posibles actividades fraudulentas.
      </p>
      <p className='lead fs-4 fw-bold mb-0 '>
        Confidencialidad de la información
      </p>
      <p>
        Amerex México no vende ni alquila la información de los usuarios. Amerex
        México puede difundir la información del titular en casos especiales
        cuando a solicitud expresa de alguna autoridad, proporcionar esta
        información pueda servir para identificar, localizar o realizar acciones
        legales contra personas que pudiesen infringir las condiciones del
        servicio de nuestros sitios web, o causar daños o interferencia sobre
        los derechos de Amerex México o sus propiedades, de otros usuarios de
        nuestros sitios web, de nuestros socios o de cualquier otra persona que
        pudiese resultar perjudicada por dichas actividades.
      </p>
      <p className='lead fs-4 fw-bold mb-0 '>
        Protección de la información personal
      </p>
      <p>
        Le recomendamos que no revele su información personal a nadie. Amerex
        México no solicitará información sensible en ninguna llamada telefónica
        o mensaje de correo no solicitado. En todo momento, el usuario es el
        responsable único y final de mantener en secreto su información
        personal, con los cuales tenga acceso a los servicios y contenidos de
        este sitio web.
      </p>
      <p className='lead fs-4 fw-bold mb-0 '>
        Cambios en el aviso de privacidad
      </p>
      <p>
        Este aviso puede tener cambios en el futuro, de ser así se le avisará
        oportunamente en la sección de Aviso de Privacidad de este sitio web.
      </p>
      <p className='lead fs-4 fw-bold mb-0 '>Aceptación de los términos</p>
      <p>
        Si el usuario utiliza los servicios de este sitio, significa que ha
        leído, entendido y acordado los términos antes expuestos. Si no está de
        acuerdo con ellos, el usuario no deberá proporcionar ninguna información
        personal, ni utilizar los servicios de este sitio web.
      </p>
      <p className='lead fs-4 fw-bold mb-0 '>Fecha de actualización</p>
      <p>Este aviso de privacidad, se actualizó el 1 de mayo de 2021.</p>
      <br />
      <Link className='link-danger' to='/'>
        <FontAwesomeIcon className='mx-1' icon={faAngleDoubleLeft} />
        Regresar al inicio
      </Link>
    </div>
  </Layout>
)

export default AvisoPrivacidad
